import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import viewClass from './view';
import modelClass from './model';

export default createWidgetFactory({
    name: 'membership_renewal_reactivation_manager',
    viewClass,
    modelClass,
});
